import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch } from "react-redux";
import { noneProfile } from "assets";
import { LoaderCircle } from "lucide-react";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Service } from "utils/services";
import { setOpenPopoverIndex } from "store/request";
import { getRequestTypeStyle } from "./getRequestTypeStyle";
const RequestCard = ({
  listRef,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  handleClickUrl,
  employeeInitRequestSearch,
  fetchMoreEmployeeRequestSearch,
  employeeRequestSearchLoading,
  getShopEmployeeRequestDetail,
  setIsDetail,
  setWarning2,
}: any) => {
  const dispatch = useDispatch();

  return (
    <InfiniteScroll
      dataLength={employeeInitRequestSearch?.data?.length || 0}
      next={() =>
        fetchMoreEmployeeRequestSearch({
          next: employeeRequestSearchLoading?.nextPageUrl,
        })
      }
      hasMore={!!employeeRequestSearchLoading?.nextPageUrl}
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        <div ref={listRef} className={`grid grid-cols-2 md:grid-cols-5 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"} gap-y-3 gap-x-2 mb-10 `}>
          {employeeInitRequestSearch?.data
            ?.filter((item: any, index: number, self: any) => index === self.findIndex((t: any) => t.id === item.id))
            ?.map((request: any, index: number) => {
              const { text, color } = getRequestTypeStyle(request.request_type, request);
              return (
                <div
                  onClick={() => {
                    if (selectProducts) {
                      setSelectedProductIds((prev: any) => (prev.includes(request.id) ? prev.filter((id: any) => id !== request.id) : [...prev, request.id]));
                      return;
                    } else {
                      if (request.is_deleted === 0) {
                        getShopEmployeeRequestDetail(request.id);
                        setIsDetail(true);
                        setWarning2(false);
                        handleClickUrl(request?.id, "request_id");
                        dispatch(setOpenPopoverIndex(1));
                      }
                    }
                  }}
                  key={index}
                  className={`group cursor-pointer relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(request.id) ? " " : ""}`}
                >
                  {request.is_deleted !== 1 && (
                    <div
                      className={`absolute z-10 top-0 right-0 ${
                        request?.status === "Pending" ? "bg-yellow-500" : request?.status === "Approved" ? "bg-green-500" : "bg-red-500"
                      }  text-white px-2 py-1 rounded-bl-md rounded-tr-md mt-0`}
                    >
                      <span className="text-sm font-bold ">{request?.status}</span>
                    </div>
                  )}
                  <div className=" w-full relative overflow-hidden aspect-square  ">
                    <ImageUrl
                      className={`rounded-t-md w-full h-full  object-cover   ${request.is_deleted === 1 && "opacity-50"} `}
                      src={!request.requester?.picture ? noneProfile : request.requester?.picture}
                      alt=""
                    />

                    <div
                      className={`${
                        selectedProductIds.includes(request.id) ? "bg-white" : ""
                      } w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                    >
                      {selectedProductIds.includes(request.id) ? (
                        <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                      ) : (
                        <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                      )}
                    </div>
                    {selectProducts === true && <div className="absolute inset-0 mx-auto top-[50%] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}
                    {request.is_deleted === 0 ? (
                      ""
                    ) : (
                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        className=" font-semibold absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[50%] cursor-pointer w-[80px] h-8 bg-black/50 rounded-full p-1"
                      >
                        Deleted
                      </button>
                    )}
                  </div>
                  <div className={`p-4  `}>
                    <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{request?.requester?.local_name}</h5>
                    <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{request?.requester?.department}</span>
                    <div key={index} className="flex flex-col items-start mt-2 w-full">
                      <div className="flex w-full ">
                        <p className={`font-bold text-[15px] my-1 w-full  rounded-md py-1  line-clamp-1 ${color}`}>{text}</p>
                      </div>
                      {request.request_type === "Leave Application Form" ? (
                        <div key={index} className="flex justify-between w-full ">
                          <p className="text-md  ">{Service.formatDateTime(request?.document?.starting_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                          <p className={` font-bold text-[15px] text-red-500 `}>
                            {request.document?.leave_period === "Full Day"
                              ? `${parseFloat(request.document?.no_of_day) + "d"}`
                              : `${parseFloat(request.document?.no_of_hour) + "h"}`}
                          </p>
                        </div>
                      ) : (
                        <div key={index} className="flex justify-between w-full ">
                          {request?.document?.working_date && (
                            <p className="text-md  ">{Service.formatDateTime(request?.document?.working_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

          {!employeeInitRequestSearch?.next_page_url && (
            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
              <b>Nothing more to load!</b>
            </p>
          )}
        </div>
      </>
    </InfiniteScroll>
  );
};

export default RequestCard;
